import React from 'react';
import theme from 'theme';
import { Text } from 'library';
import { styled, useMediaQuery } from '@mui/material';
import { useClient } from 'shared';
import { useUserContext } from 'UserContext';

import { PostAJob } from './components/PostAJob';
import { NotificationsAndPayments } from './components/NotificationsAndPayment';
import { TeacherShowcase } from './components/TeacherShowcase';

import type { DashboardSummary } from './types';

export function Dashboard() {
    const { data, loading, error, refresh } = useClient<DashboardSummary>({
        url: 'api/dashboard/summary/',
    });

    const { user } = useUserContext();
    const small = useMediaQuery(theme.breakpoints.down('md'));

    return (
        <Container>
            <Text variant="display" textStyle={{ width: '100%' }}>
                {user?.first_name ? `Hi ${user.first_name}!` : 'Hi!'}
            </Text>
            <Row small={small.toString()}>
                <PostAJob data={data} loading={loading} error={!!error} refresh={refresh} small={small} />
                <NotificationsAndPayments data={data} loading={loading} error={!!error} small={small} />
            </Row>
            <TeacherShowcase small={small} />
        </Container>
    );
}

const Container = styled('div')({
    padding: 20,
    width: '100%',
    height: '100%',
});

const Row = styled('div')(({ small }: { small: string }) => ({
    display: 'flex',
    flexDirection: small === 'true' ? 'column' : 'row',
    paddingTop: 20,
    width: '100%',
}));
